export default __webpack_public_path__ + "static/smartWorkflowImg2-7ce909f95cb86e670c5b3460d1fd7fe4.png";